// extracted by mini-css-extract-plugin
export default {"title":"styles_title__eFNaR","delegations":"styles_delegations__3ZxqM","delegation":"styles_delegation__1W+BF","link":"styles_link__dudLW","separator":"styles_separator__2cspg"};